import styled from 'styled-components';

export const Sponsor = styled.section`

    padding: 3rem 0;
    background-color: ${ props => props.theme.greyColor };

    @media (max-width: 1024px){
        padding: 3rem 1.5rem;
    }

    .container {

        .sponsors {

            display: flex;
            justify-content: space-between;

            .sponsor {

                background-color: ${ props => props.theme.lightColor };
                padding: 1rem;
                margin-right: 1rem;
                text-align: center;
                flex: 1;

                img {
                    width: 100%;
                    height: 15rem;
                }

                h3 {
                    font-size: 1.5rem;
                }

                h4 {
                    color: ${ props => props.theme.primaryColor };
                    font-size: 1rem;
                    margin: 1rem 0;
                }

                p {
                    font-weight: 300;
                }

            }

            @media (max-width: 768px){

                flex-wrap: wrap;

                .sponsor {

                    width: 47%;
                    flex: none;
                    margin-bottom: 2rem;

                }

                @media (max-width: 500px){

                    .sponsor {

                        width: 100%;
                        margin-right: 0;
                        margin-bottom: 1rem;

                    }

                }

            }

        }

    }

`